import {useDebugValue} from 'react';

import {noop} from '../../../utils';

import {useEvents} from './';

const defaultEvents = {
    onCurrentValuesChange: noop,
    onLatestValuesChange: noop
};

function useSearchEvents(props) {
    const {
        searchEvents: propsEvents
    } = props;

    const {
        events
    } = useEvents(defaultEvents, propsEvents);

    const result = {
        events
    };

    useDebugValue(result);

    return result;
}

export {useSearchEvents};
